import OrderItemExtra from "./OrderItemExtra";
import OrderItemOptionGroup from "./OrderItemOptionGroup";

export default class OrderItemDto {
    id: number;
    quantity: number;
    itemExtras: OrderItemExtra[];
    itemOptionGroups: OrderItemOptionGroup[];
    constructor(id: number, quantity: number, itemExtras: OrderItemExtra[], itemOptionGroups: OrderItemOptionGroup[]) {
        this.id = id;
        this.quantity = quantity;
        this.itemExtras = itemExtras;
        this.itemOptionGroups = itemOptionGroups;
    }
}